// limits a given number to the range [ min, max ]
const clamp = (n, min = 0, max = 1) => Math.min(max, Math.max(min, n));

export default clamp;
